import React from "react";
import {
  Filter,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  Create,
  Button,
  Link,
  List,
  DateInput,
  NumberInput,
  Datagrid,
  TextField,
  Pagination,
  DisabledInput,
  DateField,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import ItemSwitch from "../components/itemSwitch";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import moment from "moment";
const HelmetPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const HistoryButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/item_history/helmets/${props.record.id}`
    }}
    label="Device History"
  >
    <ChatBubbleIcon />
  </Button>
);

const HelmetFielter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
  </Filter>
);

const SwitchButton = props => {
  const rentals = props.record.number_rentals || 0;
  if (rentals > 0 && props.record.status === "A") {
    return (
      <ItemSwitch
        item={props.record}
        type={props.resource}
        history={props.history}
        location={props.location}
      />
    );
  }
  return <React.Fragment />;
};

export const HelmetList = props => (
  <List
    {...props}
    resource="helmets"
    pagination={<HelmetPagination />}
    filters={<HelmetFielter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Helmet ID" source="id" sortable={false} />
      <TextField
        label="Last Location"
        source="location_name"
        sortable={false}
      />
      <TextField label="Helmet Model" source="model" sortable={false} />
      <TextField label="Size" source="size" sortable={false} />
      <DateField
        label="Purchase Date"
        source="purchase_date"
        sortable={false}
      />
      <EditButton />
      <HistoryButton />
      <SwitchButton {...props} />
    </Datagrid>
  </List>
);

const HelmetTitle = object => (
  <span>
    {" Edit Helmet Device"} &quot;{object.record.model}&quot;
  </span>
);

const HelmetCreateTitle = record => <span>Create Helmet Device</span>

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const HelmetCreate = props => (
  <Create title={<HelmetCreateTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Model" source="model" />
      <TextInput label="Size" source="size" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const HelmetEdit = props => (
  <Edit title={<HelmetTitle />} {...props}>
    <SimpleForm>
      <DisabledInput label="Id" source="id" />
      <TextInput label="Model" source="model" />
      <TextInput label="Size" source="size" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}/>
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/helmets.js